import { createActionThunk } from "redux-thunk-actions";
import {
  GRAPH_INITIALIZATION,
  UPDATE_BIG_GRAPH,
  ON_CHANGE_ANALYZEFORM,
  ON_CHANGE_FACTOR_ANALYZEFORM,
  ANALYZEPAGE_DATE_CHANGED,
  RESET_ANALYZE_PAGE,
  ON_GRAPH_EXPORT,
} from "./constant";
import {
  getdetailStocks,
  getAllFactors,
  getNutrients,
  getStockGraph,
  getFoodGragh,
  getGraphReport,
} from "../services/StockService";
import { getUser } from "../services/UserService";
import moment from "moment";

const graphInitialization = (id) => {
  return async (dispatch) => {
    const users = await getUser(id);
    const data = await getdetailStocks();
    const factors = await getAllFactors();

    dispatch({
      type: GRAPH_INITIALIZATION,
      users,
      data,
      factors,
    });
  };
};
const onChangeForm = (e) => {
  return async (dispatch) => {
    var factors = [];
    let name = e.target ? e.target.name : e.name;
    let value = e.target ? e.target.value : e.value;
    if (name == "user") {
      factors = await getAllFactors(value);
    }
    dispatch({
      type: ON_CHANGE_ANALYZEFORM,
      event: e,
      factors: factors,
    });
  };
};
const onChangefactor = createActionThunk(
  ON_CHANGE_FACTOR_ANALYZEFORM,
  (id, text, subUserId, symptom) => getNutrients(id, text, subUserId, symptom)
);
const onDateChange = (val) => {
  return (dispatch) => {
    dispatch({
      type: ANALYZEPAGE_DATE_CHANGED,
      val: moment(val),
    });
  };
};

const plot = createActionThunk(UPDATE_BIG_GRAPH, (optform) =>
  Promise.all([
    getStockGraph(optform.symptom, optform.end, optform.start, optform.user),
    getFoodGragh(
      optform.factor,
      optform.nutrients,
      optform.end,
      optform.start,
      optform.user
    ),
  ])
);
const resetPage = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_ANALYZE_PAGE,
    });
  };
};
const onTfiExport = createActionThunk(ON_GRAPH_EXPORT, (optForm, exportOpt) =>
  getGraphReport(optForm, exportOpt)
);
export default {
  graphInitialization,
  plot,
  onTfiExport,
  onChangeForm,
  onChangefactor,
  onDateChange,
  resetPage,
};



// WEBPACK FOOTER //
// ./src/actions/graphActions.js